if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
      const section_title = evt.target.closest('[selecteditemmainparent]').querySelector('[selectedsectionheading]').textContent.trim();
      const section_id = evt.target.closest('[selecteditemmainparent]').querySelector('[selectedsectionheading]').getAttribute('section_id');  
       const section_category = evt.target.closest('[selecteditemparent]').getAttribute('data-category');  
       jQuery.ajax({
          type: 'GET',
          url: response.url,
          dataType: 'json',
          success: function(productdata) {
              let variant_name = '';
              for (let i = 0; i < productdata.product.variants.length; i++) {
                variant_name += productdata.product.variants[i].title + ',';
              }
              const new_var_name = variant_name.slice(0, -1).trim();
              for (let i = 0; i < productdata.product.variants.length; i++) {
              if(response.variant_id == productdata.product.variants[i].id){
              const main_price = parseInt(productdata.product.variants[i].price);
              const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
              let discount_exist = 'NA';
              if (compare_main_price > main_price) {
              discount_exist = compare_main_price - main_price;
              }
              var variant_string_id = productdata.product.variants[i].id.toString();
              const itemData = {
              item_id: productdata.product.variants[i].sku,
              item_name: response.title,
              coupon: "NA",
              discount: discount_exist,
              item_brand: "Re'equil",
              
                item_category2: productdata.product.product_type,
                item_category: section_category,
              item_list_id: variant_string_id,
              item_list_name:section_title,
              item_variant: new_var_name=="Default Title"? "NA" : new_var_name,
              price: main_price,
              quantity: 1
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({event: "add_to_cart ",ecommerce: {currency: "INR",value: main_price,items: [itemData],},});
              }
            }
            
          },
       });

              jQuery.getJSON('/cart.js', function(cart) {
        const cart_tottal_price =  cart.total_price / 100
    var jsonObj = [];
    var requests = cart.items.map(function(item) {
        return jQuery.ajax({
            type: 'GET',
            url: item.url,
            dataType: 'json'
        }).then(function(productdata) {
             var data_category = $(".cart-item[item_id='"+productdata.product.id+"']").attr("data-category");
             let variant_name = '';
            for (let i = 0; i < productdata.product.variants.length; i++) {
              variant_name += productdata.product.variants[i].title + ',';
            }
            const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
              if(item.variant_id == productdata.product.variants[i].id){
 const main_price = parseInt(productdata.product.variants[i].price);
            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
             let discount_exist = 'NA';
            if (compare_main_price > main_price) {
               discount_exist = compare_main_price - main_price;
            }
                   var variant_string_id = productdata.product.variants[i].id.toString();

            
            return {
                item_id: productdata.product.variants[0].sku,
                item_name: item.title,
                 coupon: "NA",
              discount: discount_exist,
              item_brand: "Re'equil",
                  item_category: data_category,
             item_category: productdata.product.product_type,
               item_category2: data_category,
              item_list_id: variant_string_id,
              item_list_name: productdata.product.title,
              item_variant: new_var_name=="Default Title"? "NA" : new_var_name,
              price: main_price,
              quantity: item.quantity
            };
                
              }
            }


        });
    });
    jQuery.when.apply(jQuery, requests).done(function() {
        Array.prototype.forEach.call(arguments, function(result) {
            jsonObj = jsonObj.concat(result);
        });

         window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({
              event: "view_cart ",
              ecommerce: {
                currency: "INR",
                value: cart_tottal_price,
                items: jsonObj,
              },
            });
    });
});

          
                  if ($(".UpsellWrapperCard").hasClass("active")) {
}else{
          setTimeout(function() {
             $(".UpsellWrapperCard").removeClass("active");
          },10);
     
}
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

  //         var get_tottal_quanity = 0;
  //         var free_pro_exist = 0;
  //         $(".cart-item").each(function() {
  //           var freepro_add = $(this).attr("freepro-add");
  //           var data_pro_id = $(this).attr("addition_pro-id");
  //           if(data_pro_id== '37643060052154'){
  //               free_pro_exist += parseInt(1);;
  //           }
           
  //          if(freepro_add == 'true'){
  //           var total_quantity =  $(this).find(".quantity input.quantity__input").val();

  //            get_tottal_quanity+=parseInt(total_quantity);
  //          }
  //         });
  //       if(free_pro_exist == 0){
  //                   if(get_tottal_quanity > 1){
  //             jQuery.ajax({
  //   type: 'POST',
  //   url: '/cart/add.js',
  //   data:{
  //     id: 37643060052154,
  //      properties: {"__freegift": "true"},
  //     quantity:1,
  //   },
  //   dataType: 'json',
  //   success: function(productid){
  //     jQuery.ajax({
  //       type: 'GET',
  //       url: '/cart',
  //       dataType: 'html',
  //       success: function(response){      
  //                             fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
  //                                 const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
  //                                 const bubble = document.querySelector('#cart-icon-bubble');
  //                                 bubble.innerHTML = bubbleHTML;
  //                             })
  //                             fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
  //                                 const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
  //                                 const drawer = document.querySelector('cart-drawer');
  //                                 drawer.innerHTML = newHTML;
  //                             });
  //       },
  //     });
  //   },
  // });

  //         }
  //       }

          if(document.querySelectorAll('.new_custom_drawer_products').length > 0){
  function FounderCookie(cookieName) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(cookieName + '=')) {
          return true;
        }
      }
      return false;
    }

    function startTimer(duration, display) {
      var timer = duration, minutes, seconds;
      setInterval(function () {
          minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10);
          // minutes = minutes < 10 ? "0" + minutes : minutes;
          // seconds = seconds < 10 ? "0" + seconds : seconds;

          var minutes_fst = minutes.toString().split("").map(Number)[0];
          var minutes_scd = minutes.toString().split("").map(Number)[1]; 

          var seconds_fst = seconds.toString().split("").map(Number)[0];
          var seconds_scd = seconds.toString().split("").map(Number)[1];        

          if(typeof minutes_scd !== 'undefined'){
            display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
          }else{
            display.querySelector('#timer-hours').innerHTML =  `<span>0</span><span>${minutes_fst}</span>`;
          }  

          if(typeof seconds_scd !== 'undefined'){
            display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
          }else{
            display.querySelector('#timer-minutes').innerHTML =  `<span>0</span><span>${seconds_fst}</span>`;
          }         

            
         if (FounderCookie('offerInvalid')) { }else{
          if (--timer < 0) {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 7);
            document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
          }
         }

          if (FounderCookie('offerInvalid')) {
              if(document.querySelector('.drawer_timer_outer-wrapp')){
                document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
              }
              if(document.querySelector('.new_custom_drawer_products')){
                document.querySelector('.new_custom_drawer_products').style.display = 'none';
              }
              window.localStorage.removeItem("seconds")
              window.localStorage.removeItem("minutes")
          }else{
            if(document.querySelector('.drawer_timer_outer-wrapp')){
              document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
            }
           if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'block';
           }
              window.localStorage.setItem("seconds",seconds)
              window.localStorage.setItem("minutes",minutes)            
          }

  
        

      }, 1000);
    }

        var sec  = parseInt(window.localStorage.getItem("seconds"));
        var min = parseInt(window.localStorage.getItem("minutes")); 
      
      if (FounderCookie('offerInvalid')) {
          if(document.querySelector('.drawer_timer_outer-wrapp')){
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
          }
          if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'none';
          }
          window.localStorage.removeItem("seconds")
          window.localStorage.removeItem("minutes")
      }else{
            if(document.querySelector('.drawer_timer_outer-wrapp')){
              document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
            }
           if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'block';
           }        
      }

        if(parseInt(min*sec)){
          var fiveMinutes = (parseInt(min*60)+sec);
        }else{
          var fiveMinutes = 60 * 30;
        }      
      
      var display = document.querySelector('#timer-box');
      if(parseInt(min) == 0){
          if(document.querySelector('.drawer_timer_outer-wrapp')){
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
          }
          if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'none';
          }
          window.localStorage.removeItem("seconds")
          window.localStorage.removeItem("minutes")
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 7);
          document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;        
      }else{
        startTimer(fiveMinutes, display);
      }
 
          }else{
            document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
          }
          Smile.ready().then(smileInstance => {
  $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
}).catch(err => {
  // An error has occurred will initializing smile.
});
          snaptr('track', 'ADD_CART');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {     
          if ($('[name="Eligible_products"]').length > 0) {
              var REQUIREMENT_MEETS = $('[name="Eligible_products"]').attr('minimum');
              var HAVE_MEETS = this.cart.querySelector('.totals__subtotal-value').getAttribute("cart_minimum");
              if (parseInt(HAVE_MEETS) >= parseInt(REQUIREMENT_MEETS)) {
                  var EligiblePd = [];
                  var ELIGIBLE_PRODUCT_IDS = $('[name="Eligible_products"]').val().split(",");
                  var FREE_PRODUCT_IDS = $('[name="Free_products"]').val().split(",");
                  FREE_PRODUCT_IDS = FREE_PRODUCT_IDS.map(Number);
                  var MainProductId = $('.product-form__buttons').children('[type="submit"]').attr('productid');
                  var freeProductAdd = false;var GotFreeProduct = false;
                  $.ajax({
                      url: "/cart.js",
                      type: "GET",
                      dataType: "JSON",
                      success: function(cart) {
                        
                          $.each(cart.items, function(index, item) {
                              $.each(ELIGIBLE_PRODUCT_IDS, function(index, id) {
                                  if( id == item.product_id ){
                                      GotFreeProduct = true;
                                  }                                
                                  if (item.properties) {
                                      if (item.properties.__freegift == 'true') {
                                          freeProductAdd = true;
                                      }
                                  }
                              });
                          });
                      }
                  }).done(function(response) {
                      if ( (freeProductAdd == false) && (GotFreeProduct == true) ) {
                          $.each(FREE_PRODUCT_IDS, function(index, vd) {
                              var l = '{"id":' + vd + ', "quantity" : ' + 1 + ',"properties": {"__freegift": true}' + "}";
                              EligiblePd.push(JSON.parse(l));
                          })
                          $.post("/cart/add.js", {
                              items: EligiblePd
                          }).done(function(response) {
                              fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                                  const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                                  const bubble = document.querySelector('#cart-icon-bubble');
                                  bubble.innerHTML = bubbleHTML;
                              })
                              fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                                  const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                                  const drawer = document.querySelector('cart-drawer');
                                  drawer.innerHTML = newHTML;
                              });
                          })
                      }
                  })
                }
              }
          
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if(document.querySelectorAll('.new_custom_drawer_products').length == 0){
            document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
